// extracted by mini-css-extract-plugin
var _1 = "kI8gfO9D0teDPtirugip";
var _2 = "Muy8OaUs_ClUTOjR2OrX";
export { _1 as "active", _2 as "container" }
